// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__IZT20","col":"styles_col__3P0ub","fulfillmentStatus":"styles_fulfillmentStatus__nitVx","emailCol":"styles_emailCol__19Onl"};